// extracted by mini-css-extract-plugin
export var borderRadius = "_6a-4";
export var large = "_6a-3";
export var logoContainer = "_6a-0";
export var nameLogo = "_6a-2";
export var small = "_6a-1";